/* eslint-disable */
import { AuthUserInfo, ForumProfileData } from '../domain';

import { authApiService, AuthApiService, UserAuthParams } from './user-api.service';
import { UserMapperService } from './user-mapper.service';

export type ErrorResponse = {
  response: {
    data: ApiDataErrorDTO;
  };
};

export type ApiDataErrorDTO = {
  title: string;
  status: number;
  detail: string;
  message: string;
  type: string;
};

export class UserDataMapperService {
  private _authApiService: AuthApiService = authApiService;

  public async checkAuthorization(): Promise<AuthUserInfo | null> {
    try {
      const data = await this._authApiService.checkAuthorization();
      return data !== null ? UserMapperService.getUserInfoDO(data) : data;
    } catch (err) {
      throw (err as ErrorResponse)?.response.data;
    }
  }

  public async login(
    authParams: UserAuthParams,
    captchaToken: string
  ): Promise<AuthUserInfo> {
    try {
      const data = await this._authApiService.login(authParams, captchaToken);
      return UserMapperService.getUserInfoDO(data);
    } catch (err) {
      throw (err as ErrorResponse)?.response.data;
    }
  }

  public async checkAuthOnForumNN(): Promise<ForumProfileData | null> {
    try {
      const data = await this._authApiService.checkAuthOnForumNN();
      return data !== null ? UserMapperService.getForumProfileDataDO(data) : data;
    } catch (err) {
      throw (err as ErrorResponse)?.response.data;
    }
  }

  public async authForForumNN(
    username: string,
    password: string
  ): Promise<ForumProfileData> {
    try {
      const data = await this._authApiService.loginForumsNN(username, password);
      return UserMapperService.getForumProfileDataDO(data);
    } catch (err) {
      throw (err as ErrorResponse)?.response.data;
    }
  }

  public authThroughSocialsNN(): Promise<void> {
    return this._authApiService.authThroughSocialsNN();
  }

  public async register(
    email: string,
    password: string,
    captchaToken: string
  ): Promise<void> {
    try {
      await this._authApiService.register(email, password, captchaToken);
    } catch (err) {
      throw (err as ErrorResponse)?.response.data;
    }
  }

  public async sendConfirmRegistration(
    email: string,
    captchaToken: string
  ): Promise<void> {
    try {
      await this._authApiService.sendConfirmRegistration(email, captchaToken);
    } catch (err) {
      throw (err as ErrorResponse)?.response.data;
    }
  }
}

export const userDataMapperService = new UserDataMapperService();
